import { Component, Input, OnChanges } from '@angular/core';
import { JobPostingLocationType } from '@app/models/recruiting/job-posting-location-type.model';
import { JobPostingLocationTypes } from '@app/modules/applicant-tracker/constants/job-posting-location-types.constant';
import { NotifyService } from '@app/services';
import { JobPostingLocationTypeLabelsMap } from '@applicant-tracker/constants/job-posting-location-type-labels-map.constant';
import { BadgeType } from '@humi-design-library/components/Badge/types';

@Component({
    selector: 'app-location-badge',
    templateUrl: './location-badge.template.html',
})
export class LocationBadgeComponent implements OnChanges {
    @Input() locationTypeId?: number;

    badgeableLocationTypes: { name: string; badgeType: BadgeType }[] = [
        { name: JobPostingLocationTypes.remote, badgeType: 'default' },
        { name: JobPostingLocationTypes.hybrid, badgeType: 'warning' },
    ];

    badgeableLocationData = [];
    label: string;
    visible = false;
    badgeType: BadgeType = 'default';

    locationTypeDetails = JobPostingLocationTypeLabelsMap;

    constructor(private notify: NotifyService) {}

    async ngOnInit(): Promise<void> {
        try {
            const [rawLocationTypes] = await JobPostingLocationType.all();

            this.badgeableLocationData = rawLocationTypes.filter(
                (locationType) =>
                    this.badgeableLocationTypes.findIndex((element) => element.name === locationType.name) >= 0
            );

            this.setVisibilityAndLabel();
        } catch (err) {
            this.notify.error(err);
        }
    }

    setVisibilityAndLabel(): void {
        this.visible = false;
        this.label = '';
        this.badgeType = 'default';

        const badgeableLocation = this.badgeableLocationData.find(
            (badgeableLocationDataItem) => badgeableLocationDataItem.id === this.locationTypeId
        );

        if (badgeableLocation) {
            this.visible = true;
            this.label = badgeableLocation.name;
            this.badgeType = this.getBadgeType(badgeableLocation.name);
        }
    }

    ngOnChanges(): void {
        this.setVisibilityAndLabel();
    }

    private getBadgeType(name: string): BadgeType {
        const item = this.badgeableLocationTypes.find((item) => item.name === name);

        if (item) {
            return item.badgeType;
        }

        return 'default';
    }
}
